import React from 'react';
import { Link } from 'react-router-dom';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
import { telHref } from '../../utils/format';
export function Footer() {
  const {
    settings
  } = useAdminData();
  return <footer className="border-t border-line bg-canvas-deep" data-id="element-182" data-mp="2wi9x2oazsy1l">
      <div className="mx-auto max-w-content px-5 py-12 lg:px-8" data-id="element-183" data-mp="31fjxt03u0w4q">
        <div className="flex flex-col gap-10 md:flex-row md:justify-between" data-id="element-184" data-mp="3p42x4q4wlyko">
          <div data-id="element-185" data-mp="3u3pglhbbsb1x">
            <img src={company.logoWide} alt={settings.companyName} className="h-12 w-auto md:h-14" data-id="element-186" data-mp="3u47boam94j89" />
            <p className="mt-4 text-[15px] text-ink-soft" data-id="element-187" data-mp="3ffb40eo3x886">{settings.tagline}</p>
            <p className="mt-4 text-sm text-ink-muted" data-id="element-188" data-mp="3kdw50gb6nvxo">CVR: {settings.cvr}</p>
          </div>

          <div className="flex flex-col gap-2 text-[15px] md:items-end" data-id="element-189" data-mp="by2t6ersr8my">
            {settings.phone && <a href={telHref(settings.phone)} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-190" data-mp="goj67xrpgs8s">
                {settings.phone}
              </a>}
            {settings.email && <a href={`mailto:${settings.email}`} className="text-ink transition-colors duration-200 ease-smooth hover:text-accent" data-id="element-191" data-mp="3eeomuiehm1w3">
                {settings.email}
              </a>}
            <div className="mt-3 flex gap-5 text-sm text-ink-muted" data-id="element-192" data-mp="5zwrx1yssvb0">
              <a href="#kontakt" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-193" data-mp="11ligscf0mtb">
                Kontakt
              </a>
              <a href="#privatliv" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-194" data-mp="f036ysa5a3ca">
                Privatlivspolitik
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-line pt-6 text-sm text-ink-muted" data-id="element-195" data-mp="2gt9g6pz96jd6">
          <p data-id="element-196" data-mp="2ctijy6qyjb19">
            © {new Date().getFullYear()} {settings.companyName}
          </p>
          <Link to="/admin/login" className="transition-colors duration-200 ease-smooth hover:text-ink" data-id="element-197" data-mp="fsmhdodrxvx9">
            Admin
          </Link>
        </div>
      </div>
    </footer>;
}